import {InjectionKey, inject, provide, ref, Ref} from 'vue'

const stackableLayerPassiveKey: InjectionKey<(isPassive: boolean) => void> = Symbol('StackableLayerPassive')
const stackableLayerPassThroughKey: InjectionKey<(isPassThrough: boolean) => void> = Symbol('StackableLayerPassThrough')

// A layer whose route stays in the address while its content shows on the page underneath (an item kept in the
// database page's sidebar) turns passive: it stops covering that page and stops counting as an open overlay.
export function provideStackableLayerPassive(): Ref<boolean> {
  const isPassive = ref(false)
  provide(stackableLayerPassiveKey, (value: boolean) => {
    isPassive.value = value
  })
  return isPassive
}

export function useSetStackableLayerPassive(): (isPassive: boolean) => void {
  return inject(stackableLayerPassiveKey, () => {})
}

// A layer that draws over only part of the window (an item opened as a page in the content area) lets clicks
// outside its own content reach the rail and the navigation bar, while it still counts as the open overlay.
export function provideStackableLayerPassThrough(): Ref<boolean> {
  const isPassThrough = ref(false)
  provide(stackableLayerPassThroughKey, (value: boolean) => {
    isPassThrough.value = value
  })
  return isPassThrough
}

export function useSetStackableLayerPassThrough(): (isPassThrough: boolean) => void {
  return inject(stackableLayerPassThroughKey, () => {})
}
